import moment from 'moment'

moment.locale('ru')

/**
 *
 * @param dateString - строка даты, которая приходит с сервера (используется стандартная, вида 2019-01-15 07:32:43)
 * @param format - moment формат, в который будет преобразована дата (https://momentjs.com/docs/#/displaying/format/), используется стандартная, вида 01.02.2001)
 * @param dateStringFormat - Входной формат даты, если не совпадает с стандартным
 * @returns {string} - отформатированная строка даты
 */

export default (
    dateString,
    format = 'DD.MM.YYYY',
    dateStringFormat = 'YYYY-MM-DD H:mm:ss'
) => {
    const date = moment(dateString, dateStringFormat)

    return date.isValid() ? date.format(format) : ''
}
